import { OutboundTaskTypeKey } from '../../api';
import type { Task } from './types';
import { BenefitsRoutingConfirmationActions, BenefitsRoutingSelectionActions, FormActionContainer } from './actions';
import { Typography } from 'design-system/src/components/Typography/Typography';

type TaskActionsProps = {
  setShowDeclineModal: (show: boolean) => void;
  task: Task;
  setTaskResponseLoading: (loading: boolean) => void;
  setShowNewFollowupTaskModal: (show: boolean) => void;
  rxId: string;
  drugName: string;
  drugNdc?: string;
};

const TaskActions = ({ setShowNewFollowupTaskModal, task, drugName, drugNdc }: TaskActionsProps) => {
  switch (task.task_key) {
    case OutboundTaskTypeKey.BENEFITS_ROUTING_CONFIRMATION:
      return (
        <BenefitsRoutingConfirmationActions
          taskId={task.id}
          task={task}
          setShowNewFollowupTaskModal={setShowNewFollowupTaskModal}
        />
      );

    case OutboundTaskTypeKey.BENEFITS_ROUTING_SELECTION:
      return (
        <BenefitsRoutingSelectionActions
          taskId={task.id}
          task={task}
          drugName={drugName}
          drugNdc={drugNdc}
          setShowNewFollowupTaskModal={setShowNewFollowupTaskModal}
        />
      );

    default:
      return (
        <FormActionContainer>
          <Typography styledAs="bodySmallDMSans">
            Unable to load actions for this task. Please try refreshing the page.
          </Typography>
        </FormActionContainer>
      );
  }
};

export default TaskActions;
